import { useMutation } from '@tanstack/react-query';
import { readGuideLabel } from '@/api/orders';
import type { ReadGuideLabelRequest } from '@/types/orders';

/**
 * Lectura de la etiqueta de la guía con Gemini (módulo 7, solo ADMIN).
 *
 * Es una **consulta**, no una escritura: no toca la caché ni invalida nada. El diálogo de la guía la
 * llama al elegir la foto (y con un botón «Leer de la foto») y con lo que devuelve **precarga** los
 * tres campos, siempre editables y sin pisar lo que el admin ya haya escrito.
 *
 * El backend responde 200 aunque no se pueda leer (`status: sin_gemini | no_legible | error`), así que
 * aquí un `catch` es un fallo de red/de permisos, no «la etiqueta no se leyó».
 */
export interface ReadGuideLabelInput {
  orderId: string;
  payload: ReadGuideLabelRequest;
}

export function useReadGuideLabel(tenantId: string | null) {
  return useMutation({
    mutationFn: ({ orderId, payload }: ReadGuideLabelInput) =>
      readGuideLabel(tenantId ?? '', orderId, payload),
  });
}
